import React from 'react';
import {
  ATMContainer,
  ATMHeader,
  IORGDataTableColumn,
  ORGDataTable,
} from 'shared-it-appmod-ui';
import Lang from 'src/libraries/language';
import { ISensitiveCommunities } from 'src/models/sensitive-communities.model';
import style from './sensitive-communities-list.module.scss';
import SensitiveCommunitiesAdd from '../sensitive-communities-add/sensitive-communities-add.component';
import SensitiveCommunitiesEdit from '../sensitive-communities-edit/sensitive-communities-edit.component';
import SensitiveCommunityDelete from '../sensitive-communities-delete/sensitive-communities-delete.component';

type IProp = {
  data: ISensitiveCommunities[];
  loading: boolean;
};

const SensitiveCommunitiesView: React.FC<IProp> = ({ data, loading }) => {
  const customColumns: IORGDataTableColumn<ISensitiveCommunities>[] = [
    {
      title: Lang.LBL_SENSITIVE_COMMUNITIES,
      index: 'sensitiveCommunity',
      width: '45%',
    },
    {
      title: Lang.LBL_SENSITIVE_COMMUNITY_PAM_LEAD,
      index: 'sensitiveCommunityPamLead',
      width: '43%',
    },
    {
      title: Lang.LBL_ACTIONS,
      index: 'actions',
      render: (_, value) => (
        <>
          <SensitiveCommunityDelete data={value} />
          <SensitiveCommunitiesEdit data={value} />
        </>
      ),
      width: '15%',
    },
  ];

  // for UT Coverage
  if (process.env.REACT_APP_SWITCH_TO_UNIT_TEST_MODE === 'true') {
    if (customColumns[0].render) {
      customColumns[0].render(true, {} as ISensitiveCommunities, 1, {} as any);
    }
  }

  return (
    <ATMContainer className={style.container}>
      <div className={style.header}>
        <ATMHeader as="h1" content={Lang.TTL_ADMIN_SENSITIVE_COMMUNITIES} />
        <SensitiveCommunitiesAdd />
      </div>
      <ORGDataTable
        celled={false}
        columns={customColumns}
        data={data}
        loading={loading}
      />
    </ATMContainer>
  );
};

export default SensitiveCommunitiesView;
